/**
 * 出歌流程結果卡（UI v2 步 5：由 `ChatPage.tsx` **純搬**出嚟，零行為改動）
 *
 *   顯示 `flow.song` 嘅 `SongCard`（＋〔播放〕）＋ 多版本 `VariantPicker`（逐版可以分享）。
 *   ⚠️ 出現條件（`flow.song && flow.phase !== 'lyrics'`）留喺父層。
 */
import type { TFunction } from 'i18next';
import SongCard from '@coeldery/song-card';
import VariantPicker from '@coeldery/variant-picker';
import ShareButton from '@coeldery/share-button';
import { songAudioUrl } from '../../player/playerModel';
import type { useSongFlow } from '../../hooks/useSongFlow';
import { ROW_BTN, PLAY_BTN } from './styles';

type FlowSong = NonNullable<ReturnType<typeof useSongFlow>['song']>;

export interface SongResultProps {
  t: TFunction;
  song: FlowSong;
  busy: boolean;
  deviceId: string;
  playSong: (songId: string) => void;
  onPickVariant: (index: number) => void;
}

export default function SongResult({ t, song, busy, deviceId, playSong, onPickVariant }: SongResultProps) {
  return (
    <div style={{ padding: '0 12px 16px' }}>
      <SongCard
        title={song.title}
        lyrics={song.lyrics}
        moodTags={song.moodTags}
        status={song.status}
        error={song.error}
        action={
          song.audioKey ? (
            <button type="button" onClick={() => playSong(song.id)} style={PLAY_BTN}>
              {t('player_play')}
            </button>
          ) : null
        }
      />
      {song.status === 'succeeded' && (song.variants?.length ?? 0) > 1 ? (
        <VariantPicker
          variants={song.variants ?? []}
          pickedIndex={song.pickedIndex ?? 0}
          busy={busy}
          onPick={onPickVariant}
          audioSrcFor={(index) => `/api/song/audio/${song.id}?deviceId=${encodeURIComponent(deviceId)}&variant=${index}`}
          /** ⭐ 1.1.0（產品負責人）：**每個版本都可以即刻分享**（真 mp3；`variant=` 由 `songAudioUrl` 砌） */
          renderActions={(v) => (
            <ShareButton
              title={`${song.title ?? ''} · ${t('variant_label')} ${v.index + 1}`}
              text={t('share_song_text')}
              url="https://cosingery.com"
              fileUrl={songAudioUrl(song.id, { deviceId }, { variant: v.index })}
              style={{ ...ROW_BTN, minHeight: '36px', borderColor: 'var(--color-divider)' }}
            />
          )}
        />
      ) : null}
    </div>
  );
}
